// extracted by css-extract-rspack-plugin
export default {"root":"id3lJPCCZgwLnllq","actions":"XRRfn34xCtQ9YXvJ"};